import { formatDate, type DateInput } from "@its-engineering-and-development/ui-foundation/utils";

interface TimelineItemProps {
    /** Primary label describing the event. */
    title: string;
    /** Raw date value (ISO string, timestamp or Date); formatted by the component. */
    date: DateInput;
}

/** Figma date format, e.g. "2/19/2026, 9:00:00 AM". */
const DATE_FORMAT = "M/d/yyyy, h:mm:ss a";

/**
 * Generic timeline entry rendered as a blue dot with a title and formatted date.
 *
 * Meant to be used inside a vertically spaced container (e.g. `space-y-8`).
 */
export function TimelineItem({ title, date }: TimelineItemProps) {
    const formattedDate = formatDate(date, DATE_FORMAT);

    return (
        <div className="flex gap-4">
            <div className="mt-1.5 h-3 w-3 flex-shrink-0 rounded-full bg-blue-500" />
            <div>
                <p className="mb-2 font-normal text-gray-900">{title}</p>
                <p className="text-sm text-gray-500">{formattedDate}</p>
            </div>
        </div>
    );
}
